import React, { useEffect } from "react";
import { Container, Paper, TextField, Typography } from "@material-ui/core";

import { useStyles } from "../../assets/styles";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { connect } from "react-redux";
import { getRestaurants, deleteRestaurant } from "../../actions/restaurants";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useForm } from "react-hook-form";

function DeleteStore({ returnNav, restaurants, getRestaurants, deleteRestaurant }) {
	const { register, handleSubmit } = useForm();

	const classes = useStyles();
	useEffect(() => {
		if (restaurants.length === 0) {
			getRestaurants();
		}
	}, [restaurants, getRestaurants]);

	const pickRestaurant = ({ restaurant }) => {
		if (window.confirm("Esta acción es irreversible, esta completamente seguro de querer proceder?")) {
			deleteRestaurant(restaurant);
		}
	};

	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				<Typography variant="h4">Restaurantes</Typography>

				<TextField
					style={{ width: "300px", margin: 20 }}
					select
					SelectProps={{
						native: true,
						IconComponent: () => <ArrowDropDownIcon />,
					}}
					name="restaurant"
					inputRef={register({ required: true, minLength: 2 })}
				>
					{restaurants.map((store) => (
						<option key={store.path} value={store.path}>
							{store.name}
						</option>
					))}
				</TextField>
				<ButtonWithStyle onClick={handleSubmit(pickRestaurant)}>Borrar</ButtonWithStyle>
				<ButtonWithStyle onClick={returnNav}>Regresar</ButtonWithStyle>
			</Paper>
		</Container>
	);
}

const mapStateToProps = ({ restaurants }) => {
	return { restaurants };
};

export default connect(mapStateToProps, { getRestaurants, deleteRestaurant })(DeleteStore);
